// Blog Visit Service - Manages visit tracking for blog posts
// Following the same architecture as BlogService
import BlogService from './BlogService';

class BlogVisitService {
  constructor() {
    // Cache local para evitar llamadas repetidas
    this.visitCounts = {};
  }

  // Track a visit to a blog post
  async trackVisit(postSlug) {
    if (!postSlug) return;
    
    try {
      const response = await BlogService.trackVisit(postSlug);
      if (response && response.visit_count !== undefined) {
        this.visitCounts[postSlug] = response.visit_count;
        console.log(`📊 Visit tracked for post: ${postSlug}, total visits: ${response.visit_count}`);
        return response.visit_count;
      }
    } catch (error) {
      console.error('Error tracking visit:', error);
      // Fallback: increment local count
      this.visitCounts[postSlug] = (this.visitCounts[postSlug] || 0) + 1;
      return this.visitCounts[postSlug];
    }
  }

  // Get visit count for a specific post (from cache or post data)
  getVisitCount(postSlug, postData = null) {
    // Si tenemos datos del post, usar el visit_count del backend
    if (postData && postData.visit_count !== undefined) {
      this.visitCounts[postSlug] = postData.visit_count;
      return postData.visit_count;
    }
    
    // Si no, usar cache local
    return this.visitCounts[postSlug] || 0;
  }

  // Get all visit counts (for debugging/admin purposes)
  getAllVisitCounts() {
    return { ...this.visitCounts };
  }

  // Format visit count for display (e.g., 1.2K, 1.5M)
  formatVisitCount(count) {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(1) + 'M';
    } else if (count >= 1000) {
      return (count / 1000).toFixed(1) + 'K';
    }
    return count.toString();
  }
}

// Create singleton instance
const blogVisitService = new BlogVisitService();

export default blogVisitService;
